/**
 * Motivos de consulta predefinidos para Cita Rápida — Manicuría.
 * 
 * Cada motivo se asigna a un tratamiento existente en la clínica.
 * Si el tratamiento no existe, el backend lo crea automáticamente.
 */
const MOTIVOS_MANICURIA = [
  { id: 'man_tradicional', label: '💅 Manicura tradicional', tratamiento: 'manicura_tradicional', duracion: 60 },
  { id: 'man_semi', label: '💎 Semipermanente', tratamiento: 'semipermanente', duracion: 75 },
  { id: 'man_nailart', label: '🎨 Nail art / Decoración', tratamiento: 'nail_art', duracion: 90 },
  { id: 'man_acrilicas', label: '📐 Uñas acrílicas', tratamiento: 'acrilicas', duracion: 90 },
  { id: 'man_gel', label: '🧴 Uñas de gel', tratamiento: 'gel', duracion: 75 },
  { id: 'man_pedicura', label: '🦶 Pedicura', tratamiento: 'pedicura', duracion: 60 },
  { id: 'man_retiro', label: '🔧 Retiro / Remoción', tratamiento: 'retiro', duracion: 45 },
  { id: 'man_otro', label: '🎯 Otro servicio de uñas', tratamiento: 'general_manicuria', duracion: 60 },
];

export default MOTIVOS_MANICURIA;
